'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('../../button');

var _button2 = _interopRequireDefault(_button);

require('../styles/PrimaryButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  className: _react2.default.PropTypes.string,
  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired,
  spinnerColor: _react2.default.PropTypes.string
};

function PrimaryButton(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$children = _ref.children,
      children = _ref$children === undefined ? '' : _ref$children,
      _ref$spinnerColor = _ref.spinnerColor,
      spinnerColor = _ref$spinnerColor === undefined ? '#FFF' : _ref$spinnerColor,
      props = _objectWithoutProperties(_ref, ['className', 'children', 'spinnerColor']);

  var classNames = 'cp-primary-btn btn-primary ' + className;

  return _react2.default.createElement(
    _button2.default,
    _extends({ className: classNames, spinnerColor: spinnerColor }, props),
    children
  );
}

PrimaryButton.propTypes = propTypes;

exports.default = PrimaryButton;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/buttons/lib/components/primary/components/PrimaryButton.component.js
// module id = 219
// module chunks = 0 1 3 4 5